import InfoTip from "../../InfoTip";
import "./drawerStats.css";

/** Horizontal bars scaled to the largest figure in this list. */
export default function WormList({ title, hint, items }) {
  const numbers = items.map((item) => Number(item.value)).filter((value) => Number.isFinite(value));
  const max = numbers.length ? Math.max(...numbers) : 0;
  if (!items.length) return null;

  return (
    <div className="ds-picture">
      {title ? (
        <p className="ds-dest-lead">
          <span className="v2-info-tip--label">
            {title}
            {hint ? <InfoTip text={hint} /> : null}
          </span>
        </p>
      ) : null}
      <ul className="ds-worms">
        {items.map((item) => {
          const value = Number(item.value);
          const known = Number.isFinite(value) && max > 0;
          const width = known ? (value / max) * 100 : 0;
          return (
            <li key={item.key}>
              <div className="ds-worm-top">
                <span>
                  {item.label}
                  {item.note ? <span className="ds-worm-note"> {item.note}</span> : null}
                </span>
                <strong>{item.display != null ? item.display : known ? String(value) : "—"}</strong>
              </div>
              <div
                className="ds-worm-track"
                role="img"
                aria-label={`${item.label}: ${item.display != null ? item.display : known ? value : "not published"}`}
              >
                {known && value > 0 ? (
                  <span className="ds-worm-fill" style={{ width: `${width}%`, minWidth: 2 }} />
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
